const initialData = {
  userInfo: {},
};

const userReducers = (state = initialData, action) => {
  switch (action.type) {
    case "LOGIN_USER":
      return {
        ...state,
        userInfo: action.payload,
      };

    default:
      return state;
  }
};

export default userReducers;
